// extracted by mini-css-extract-plugin
module.exports = {"fucsia":"fucsia__1t4R-","outline":"outline__1bRYr","form-check":"form-check__2NRsz","form-check-label":"form-check-label__15-re","text-left":"text-left__2ZYuo"};